import {
  ADD_BATTERY_LEVEL,
  UPDATE_BATTERY_LEVEL,
  DELETE_BATTERY_LEVEL,
  SET_BATTERY_LEVEL,
} from "../types";

const initialState = {
  allBatteryLevels: {
    type: null,
    categories: [],
    data: [],
    series: [],
    today_recent_record: null,
    total_records: 0,
  },
};
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_BATTERY_LEVEL: {
      return {
        ...state,
        allBatteryLevels: {
          ...state.allBatteryLevels,
          type: payload.type,
          categories: payload.categories,
          data: payload.data,
          series: payload.series,
          today_recent_record: payload.today_recent_record,
          total_records: parseInt( payload.total_records, 10 ),
        },
      };
    }
    case ADD_BATTERY_LEVEL: {
      return {
        ...state,
        allBatteryLevels: {
          type: payload.type,
          data:
            state.allBatteryLevels.data?.length > 0
              ? [payload.data, ...state.allBatteryLevels.data]
              : [payload.data],
          series: payload.graph_data.series,
          categories: payload.graph_data.categories,
          today_recent_record: payload.graph_data.today_recent_record,
          total_records: parseInt( payload.graph_data.total_records, 10 ),
        },
      };
    }
    case UPDATE_BATTERY_LEVEL: {
      return {
        ...state,
        allBatteryLevels: {
          ...state.allBatteryLevels,
          type: payload.type,
          data: state.allBatteryLevels.data.map((item) => {
            if (item.id === payload.data.id) {
              return payload.data;
            }
            return item;
          }),
          today_recent_record: payload.graph_data.today_recent_record,
          total_records: parseInt( payload.graph_data.total_records, 10 ),
        },
      };
    }
    case DELETE_BATTERY_LEVEL: {
      return {
        ...state,
        allBatteryLevels: {
          ...state.allBatteryLevels,
          data: state.allBatteryLevels.data.filter((item) => {
            return item.id !== payload.id;
          }),
          series: payload.graph_data.series,
          categories: payload.graph_data.categories,
          type: payload.type,
          today_recent_record: payload.graph_data.today_recent_record,
          total_records: parseInt( payload.graph_data.total_records, 10),
        },
      };
    }
    default:
      return state;
  }
}
